import { eventChannel } from 'redux-saga';

// eslint-disable-next-line import/prefer-default-export
export function createOneTrustChannel() {
  return eventChannel((emitter) => {
    const handler = () => {
      emitter({
        oneTrustBoxClosed: true
      });
    };

    if (window.cookieyes) {
      document.addEventListener('cookieyes_consent_update', handler);
    }

    return () => { };
  });
}
